import { create } from 'zustand';
import type { ChatbotConfig } from '../types/config';

interface ConfigState {
  config: ChatbotConfig | null;
  setConfig: (config: ChatbotConfig) => void;
  getConfig: () => ChatbotConfig | null;
  getBaseUrl: () => string;
  getWebSocketUrl: () => string;
  getEndpoint: (endpointName: keyof ChatbotConfig['endpoints']) => string;
}

const useConfigStore = create<ConfigState>((set, get) => ({
  config: null,
  
  setConfig: (config: ChatbotConfig) => {
    set({ config });
  },
  
  getConfig: () => {
    return get().config;
  },
  
  getBaseUrl: () => {
    const config = get().config;
    if (!config) {
      console.warn('Config not initialized. Please set config before using the chatbot.');
      return '';
    }
    return config.baseUrl;
  },
  
  getWebSocketUrl: () => {
    const config = get().config;
    if (!config) {
      console.warn('Config not initialized. Please set config before using the chatbot.');
      return '';
    }
    return config.websocketUrl;
  },
  
  getEndpoint: (endpointName: keyof ChatbotConfig['endpoints']) => {
    const config = get().config;
    if (!config) {
      console.warn('Config not initialized. Please set config before using the chatbot.');
      return '';
    }
    return config.endpoints[endpointName];
  },
}));

export default useConfigStore;
